
// import { createOrg } from '@/services'
import {
  inviteEmailValid,
  inviteAdmin } from '@/services/organization'
export default {
  namespaced: true,
  state: {
    submitting: false
  },
  mutations: {
    setSubmitting (state, type) {
      state.submitting = type
    }
  },
  actions: {
    // 邮箱重复验证
    async ajaxEmail ({ commit }) {
      commit('setSubmitting', true)
      const chain = await inviteEmailValid()
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config({ tip: false })
      return chain
    },

    // 邀请人员表单提交
    async ajaxSave ({ commit, dispatch }) {
      commit('setSubmitting', true)
      const chain = await inviteAdmin()
        .onSuccess(async () => {
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
      return chain
    }
  }
}
